import {useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';
import InvoiceAttachmentPreview from '../components/pages/TransactionsPage/InvoiceAttachmentPreview';
import {invoicesActions} from '../state/actions/invoice.actions';

const useInvoiceAttachmentPreview = ({ multiple = true, variant = 'backend' } = {}) => {
  const dispatch = useDispatch();
  const getInvoiceDetails = {
    accounting: invoicesActions.getAccountingInvoice,
    backend: invoicesActions.getInvoice,
  }[variant] || invoicesActions.getInvoice;

  const [invoicesAttachments, setAttachmentsPreviews] = useState({
    loading: false,
    invoices: {},
  });

  const [previewAttachment, setPreviewAttachment] = useState(undefined);

  const loadInvoiceDetails = (id) => {
    if (!id) return;

    setAttachmentsPreviews({ ...invoicesAttachments, loading: true });

    dispatch(getInvoiceDetails(
      id,
      (invoice) => {
        const invoiceFile = {
          file: invoice.file_url,
          name: invoice.file_name,
        };
        setPreviewAttachment(invoiceFile);
        setAttachmentsPreviews(prevState => ({
          ...prevState,
          loading: false,
          invoices: {
            ...prevState.invoices,
            [id]: invoiceFile,
          },
        }));
      },
      () => {
        setAttachmentsPreviews(prevState => ({ ...prevState, loading: false }));
      }
    ));
  };

  const showPreview = (id) => {
    if (invoicesAttachments.loading) return;
    const previewFile = invoicesAttachments.invoices[id];
    if (previewFile) {
      setPreviewAttachment(previewFile);
    } else {
      loadInvoiceDetails(id);
    }
  };

  const tooltipContent = useMemo(() => (
    <>
      {invoicesAttachments.loading && 'Loading...'}
      {previewAttachment && (
        <InvoiceAttachmentPreview
          attachment={previewAttachment}
          className={invoicesAttachments.loading ? 'd-none' : ''}
          multiple={multiple}
        />
      )}
    </>
  ), [invoicesAttachments, multiple, previewAttachment]);

  return {
    invoicesAttachments,
    previewAttachment,
    showPreview,
    tooltipContent,
  };
};

export default useInvoiceAttachmentPreview;
